import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';

interface Props {
  courseId: number;
  onDelete: () => Promise<void>;
  userId: number;
}

const FollowUsersDeleteAnalytics = ({ courseId, onDelete, userId }: Props) => {
  const {
    messages,
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const handleDeleteAnalytics = async (values?: {
    deletionReason?: string;
  }) => {
    try {
      let url = `/admin/courses/${courseId}/users/${userId}/analytics`;

      if (values?.deletionReason) {
        const params = new URLSearchParams({
          deletionReason: values.deletionReason
        });
        url += `?${params.toString()}`;
      }

      await api.delete(url);
      await onDelete();

      return true;
    } catch (err) {
      return false;
    }
  };

  return requireReasonWhenDeletingData ? (
    <ConfirmDeleteButton
      buttonIsDropdown={true}
      buttonText={messages.userDeleteAllAnalytics}
      confirmText={messages.userDeleteAllAnalyticsConfirm}
      confirmTitle={messages.userDeleteAllAnalytics}
      id="deletionReasonAnalytics"
      onConfirm={handleDeleteAnalytics}
      stopPropagation={true}
      successMessage={messages.userDeleteAllAnalyticsSuccess}
    />
  ) : (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.userDeleteAllAnalytics}
      category="danger"
      confirmText={messages.userDeleteAllAnalyticsConfirm}
      confirmTitle={messages.userDeleteAllAnalytics}
      onConfirm={handleDeleteAnalytics}
      stopPropagation={true}
      successMessage={messages.userDeleteAllAnalyticsSuccess}
    />
  );
};

export default FollowUsersDeleteAnalytics;
